import Vue from "vue";
import InputFacade from "vue-input-facade";

export default Vue.use(InputFacade);
